import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter, Link } from "react-router-dom"



//i18n
import { withTranslation } from "react-i18next"

const SidebarContentForSuperAdmin = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method smultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" >
                {/* <i className="fas fa-users"></i> */}
                <i className="mdi mdi-account-group"></i>
                <span>{props.t("Accounts")}</span>
              </Link>

            </li>
            <li>
              <Link to="/dashboard-content-editor-list" >
                {/* <i className="fas fa-pen-square"></i> */}
                <i className="bx bx-edit-alt"></i>
                <span>{props.t("Content Editors")}</span>
              </Link>

            </li>
            <li>
              <Link to="/create/account-owner" >
                {/* <i className="fas fa-user-plus"></i> */}
                <i className="mdi mdi-account-plus"></i>
                <span>{props.t("Create Account")}</span>
              </Link>
            </li>

            <li>
              <Link to="/create/content-editor" >
                <i className="bx bx-edit"></i>
                <span>{props.t("Create Content Editor")}</span>
              </Link>
            </li>











            {/* <li>
              <Link to="/purchase-history"> */}
            {/* <i className="fas fa-tag"></i> */}
            {/* <i className="bx bx-cart-alt"></i>
                <span>{props.t("Purchase History")}</span> */}
            {/* </Link>
              </li> */}
            {/* <li>
              <Link to="/manage-price" > */}
            {/* <i className="fas fa-dollar-sign"></i> */}
            {/* <i className="fas fa-hand-holding-usd"></i>
                <span>{props.t("Manage Price")}</span>
                </Link>
                </li> */}



            {/* <li>
              <Link to="/create-coupon"> */}
            {/* <i className="fas fa-money-bill-wave"></i> */}
            {/* <i className="mdi mdi-ticket-percent"></i>
                <span>{props.t("Create Coupon")}</span>
              </Link>
               </li> */}

            {/* <li>
              <Link to="/Editor-Testing">
                <i className="fas fa-money-bill-wave"></i>
                <i className="mdi mdi-file-edit"></i>
                <span>{props.t("CKEditor Testing")}</span>
              </Link>
               </li> */}







          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContentForSuperAdmin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContentForSuperAdmin))
